import { clientHttp } from '@/common/http';
import {
  type GetBigPromotionApi,
  getBigPromotionResponseSchema,
} from './get-big-promotion';

export const getBigPromotion: GetBigPromotionApi = async ({ signal }) => {
  const json = await clientHttp
    .get('/api/promotions/big-promotion', { signal })
    .json();
  return getBigPromotionResponseSchema.parse(json);
};
